import { render, staticRenderFns } from "./VBackground.vue?vue&type=template&id=b9e57654&"
import script from "./VBackground.vue?vue&type=script&lang=ts&"
export * from "./VBackground.vue?vue&type=script&lang=ts&"
import style0 from "./VBackground.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports